import { Box, Button, Center, Flex, Text } from '@chakra-ui/react';
import Export from '../../export';
import { QuestionIcon } from '@chakra-ui/icons';
import { CopyBlueIcon } from '@assets/icons/index';
import { FailedIcon } from '@assets/icons';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import useGetAuditTrailParahubErrorDetail from '@domain/parahub/useGetAuditTrailParahubErrorDetail';

export default function FailedSummary() {
    const { selectedAuditTrail } = useMainState();
    const errorDetail = useGetAuditTrailParahubErrorDetail(selectedAuditTrail);
    const failedData = errorDetail?.data ?? [];

    return (
        <Box>
            <Box p={'16px'} bg={'semantic.200'} borderRadius={'8px'} mt={'24px'}>
                <Flex alignItems={'center'} gap={'8px'} justifyContent={'space-between'} mb={'16px'}>
                    <Text fontWeight={'bold'}>Detail Masalah</Text>

                    <CopyBlueIcon />
                </Flex>

                <Box bg={'danger.100'} p={'16px'} borderRadius={'8px'}>
                    <Text color={'danger.600'} fontSize={'xs'} fontWeight={'bold'} mb={3}>
                        {failedData.length} Kesalahan Ditemukan:
                    </Text>

                    <Box maxH={'150px'} overflowY={'auto'}>
                        {failedData.map((item, index) => (
                            <Flex key={index} gap={'8px'} ms={'12px'} mb={2}>
                                <Box width="16px" mt="4px">
                                    <FailedIcon size={16} />
                                </Box>
                                <Text fontSize={'sm'}>
                                    {item?.description}; {item?.line}
                                </Text>
                            </Flex>
                        ))}
                    </Box>
                </Box>
            </Box>

            <Center mt="24px" gap={'8px'}>
                <Button variant={'secondary'} leftIcon={<QuestionIcon />} color={'semantic.500'}>
                    Bantuan
                </Button>
                <Export />
            </Center>
        </Box>
    );
}
